import { Link } from "react-router-dom";

const Header = () => (
  <header className="text-white p-4 flex justify-between items-center">
    <div className="flex items-center gap-4">
      <img
        src="/logo.avif" // Asegúrate de que esta ruta exista en tu carpeta public
        alt="Logo de Coffe"
        className="w-12 h-12 rounded-full"
      />
      <h1 className="text-2xl font-bold">Bienvenidos a Coffe</h1>
      <h3 className="text-sm sm:text-base">lo mejor de lo mejor</h3>
    </div>

    <nav className="flex gap-4">
      <Link to="/">Inicio</Link>
      <br />
      <Link to="/productos">Productos</Link>
      <br />
      <Link to="/contacto">Contacto</Link>
    </nav>
  </header>
);

export default Header;
